import { Component, FunctionComponent, ReactElement, ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { captureException } from 'lib/reporting';

interface ErrorBoundaryProps {
  children: ReactNode;
  fallback?: () => ReactElement<unknown, string | FunctionComponent | typeof Component> | null;
  onCatch?: (error: Error) => void;
}
export default function PersonaErrorBoundary({
  children,
  onCatch = (error) => {
    captureException(error);
  },
  fallback = () => null,
}: ErrorBoundaryProps) {
  return (
    <ErrorBoundary
      FallbackComponent={fallback}
      onError={onCatch}
      onReset={() => {
        // reloading the page to restore the initial state
        // of the current page
        window.location.reload();
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
